// * Import required libraies
import React from "react";
import { connect } from "react-redux";

// * Import Custom Component
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Loader from "../../components/Loader/Loader";

function LayoutTopBottom(props = {}) {
  const { user = {}, children = <></> } = props;
  return (
    <>
      {user.screen.isDashboardLoading && (
        <section className={`dashboard-loader-container`}>
          <Loader />
        </section>
      )}
      <div className={`page layout-top-bottom`}>
        <Header />
        <main>
          <section className={`content`}>
            <section className={`main-content-data`}>{children}</section>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(LayoutTopBottom);
